import { actions } from "./action-list";

export function pendingSettlementsFetched(value) {
  return {
    type: actions.PENDING_SETTLEMENT,
    value,
  };
}

export function settledSettlementsFetched(value) {
  return {
    type: actions.SETTLED_SETTLEMENT,
    value,
  };
}
export function settlementSummaryFetched(value) {
  return {
    type: actions.SETTLEMENT_SUMMARY,
    value,
  };
}

export function settlementLedgerFetched(value) {
  return {
    type: actions.SETTLEMENT_LEDGER,
    value,
  };
}

export function previousSettlementsFetched(value) {
  return {
    type: actions.PREVIOUS_SETTLEMENT,
    value,
  };
}

export function settlementUploadSheet(value) {
  return {
    type: actions.SETTLEMENT_UPLOAD,
    value,
  };
}

export function settlementUploadSheetFailure(value) {
  return {
    type: actions.SETTLEMENT_UPLOAD_FAILURE,
    value,
  };
}
